import { useLingui } from '@lingui/react/macro';

import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';
import { documentTypes } from '../../../tradingHistory.helpers';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const ArticlesOfAssociation = ({
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  const { t } = useLingui();

  return (
    <DocumentRequirement
      title={t`Articles of association`}
      documentType={documentTypes.aktienregisterauszug_hochladen}
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>Bitte laden Sie Ihren Gewerbeschein hoch.</p>
    </DocumentRequirement>
  );
};
